import Vue from 'vue'
import Vuex from 'vuex'
import { axiospost } from 'utils/axiosMethods'
import router from '@/router'
import {
  dynamicRoutes,
  visualizeRoute,
  fireStationRoute,
  visualizeWrjRoute,
  visualizeWrj2Route,
  spacerBarRoute,
  pumpMonitorRoute,
  waterSystemRoute
} from '@/router'
import continuing from './modules/continuing'
import visualize from './modules/visualize'
import deviceList from './modules/gotparams'
import Dictionary from './modules/Dictionary'
import home from './modules/home'
import wbhtgl from './modules/wbhtgl'

Vue.use(Vuex)

const store = new Vuex.Store({
  // ...
  state: {
    user: JSON.parse(localStorage.getItem('user')),
    theme: localStorage.getItem('theme') || 'blue',
    loginSuper: JSON.parse(localStorage.getItem('loginSuper')),
    menu: [],
    // 存储从后台获取权限的菜单数据
    menuList: [],
    permissionList: [],
    userAreaList: [],
    startSocket: false,
    isHasVisualize: false,
    isHasFireStation: false,
    isHasSpacerBar: false,
    isHasPumpMonitor: false,
    isHasWaterSystem: false,
    historyAlarm: []
  },
  getters: {},
  mutations: {
    changeTheme(state, payload) {
      state.theme = payload
    },
    filterMenuList(state, resolve) {
      let data
      if (localStorage.getItem('loginSuper')) {
        let json = JSON.parse(localStorage.getItem('loginSuper'))
        let { id, isAdmin, phone, name } = json
        data = { id, isAdmin, phone, name }
      } else if (localStorage.getItem('user')) {
        let json = JSON.parse(localStorage.getItem('user'))
        let { id, isAdmin, status, phone, name } = json
        data = { id, isAdmin, status, phone, name }
      }
      if (data) {
        axiospost('operation/permission/findPermission', {
          ...data
        }).then(res => {
          let menuList = res.data.data.menuList
          state.menuList = menuList
          function filterRoutes(routes) {
            return routes.filter(r => {
              let m = menuList.find(it => it === r.name)
              if (m && r.children) {
                r.children = filterRoutes(r.children)
              } else {
                r.children = []
              }
              return !!m
            })
          }
          resolve(filterRoutes(dynamicRoutes))
        })
      }
    },
    filterCommonRouter(state, { mark, resolve }) {
      let data
      if (localStorage.getItem('loginSuper')) {
        let json = JSON.parse(localStorage.getItem('loginSuper'))
        let { id, isAdmin, phone, name } = json
        data = { id, isAdmin, phone, name }
      } else if (localStorage.getItem('user')) {
        let json = JSON.parse(localStorage.getItem('user'))
        let { id, isAdmin, status, phone, name } = json
        data = { id, isAdmin, status, phone, name }
      }
      if (data) {
        if (state.menuList.length) {
          function filterRouters() {
            return mark.filter(r => {
              let m = state.menuList.find(it => it === r.name)
              return !!m
            }).length
          }
          resolve(filterRouters())
        }
      }
    },
    SET_Visualize(state, data) {
      state.isHasVisualize = data
    },
    SET_FireStation(state, data) {
      state.isHasFireStation = data
    },
    SET_SpacerBar(state, data) {
      state.isHasSpacerBar = data
    },
    SET_PumpMonitor(state, data) {
      state.isHasPumpMonitor = data
    },
    SET_WaterSystem(state, data) {
      state.isHasWaterSystem = data
    },
    SET_MENU(state, menu) {
      state.menu = menu
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_LoginSuper(state, loginSuper) {
      state.loginSuper = loginSuper
    },
    SET_History_Alarm(state, historyAlarm) {
      state.historyAlarm = historyAlarm
    },
    loginOut(state) {
      state.menu = []
      state.user = []
      localStorage.removeItem('companyId')
      localStorage.removeItem('user')
      localStorage.removeItem('loginSuper')
      localStorage.removeItem('username')
      localStorage.removeItem('token')
      localStorage.removeItem('userId')
      localStorage.removeItem('userphone')
      sessionStorage.removeItem('startSocket')
    },
    changeUser(state, name) {
      state.username = name
      localStorage.setItem('username', name)
    },
    SET_SOCKET(state, trige) {
      state.startSocket = trige
    },
    SET_USER_AREA(state, list) {
      state.userAreaList = list
    }
  },
  actions: {
    async addRoutes({ commit, state }) {
      /*  获取后台给的权限数组 */
      /*  根据后台权限跟我们定义好的权限对比，筛选出对应的路由并加入到path=''的children */
      let permissionList = state.menu.length
        ? state.menu
        : await new Promise(resolve => commit('filterMenuList', resolve))
      let isHasVisualize = await new Promise(resolve =>
        commit('filterCommonRouter', {
          mark: visualizeRoute,
          resolve
        })
      )
      let isHasFireStation = await new Promise(resolve =>
        commit('filterCommonRouter', {
          mark: fireStationRoute,
          resolve
        })
      )
      let isHasSpacerBar = await new Promise(resolve =>
        commit('filterCommonRouter', {
          mark: spacerBarRoute,
          resolve
        })
      )

      commit('SET_Visualize', isHasVisualize == 0 ? false : true)
      commit('SET_FireStation', isHasFireStation == 0 ? false : true)
      commit('SET_SpacerBar', isHasSpacerBar == 0 ? false : true)
      let isHasPumpMonitor = await new Promise(resolve =>
        commit('filterCommonRouter', {
          mark: pumpMonitorRoute,
          resolve
        })
      )
      commit('SET_PumpMonitor', isHasPumpMonitor == 0 ? false : true)

      let isHasWaterSystem = await new Promise(resolve => {
        commit('filterCommonRouter', {
          mark: waterSystemRoute,
          resolve
        })
      })
      commit('SET_WaterSystem', isHasWaterSystem == 0 ? false : true)
      if (isHasVisualize) {
        router.addRoutes(visualizeRoute)
      }
      if (isHasFireStation) {
        router.addRoutes(fireStationRoute)
        router.addRoutes(visualizeWrjRoute)
        router.addRoutes(visualizeWrj2Route)
      }
      if (isHasSpacerBar) {
        console.log('spacerBarRoute', isHasSpacerBar)
        router.addRoutes(spacerBarRoute)
      }
      if (isHasPumpMonitor) {
        router.addRoutes(pumpMonitorRoute)
      }
      if (isHasWaterSystem) {
        router.addRoutes(waterSystemRoute)
      }
      /* 生成左侧导航菜单 */
      commit('SET_MENU', permissionList)
      /*  动态添加路由 */
      router.addRoutes(permissionList)
    }
  },
  modules: {
    continuing,
    visualize,
    deviceList,
    Dictionary,
    home,
    wbhtgl
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js